import { LoadingOutlined } from "@ant-design/icons";
import { Button, Spin, Typography } from "antd";
import { ReactElement, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LoginFormLayout } from "../../../layouts/LoginFormLayout/LoginFormLayout";
import { useAppDispatch, useAppSelector } from "../../../store/reduxHooks";
import {
  PASSWORD_RECOVERY_MAIL,
  TYPE_POSITION,
} from "../../../store/slice/authSliceLogin/authSliceLogin";
import { useThunkActionLoadingState } from "../../../utils/Hooks/useThunkActionLoadingState";
import { useTimer } from "../../../utils/Hooks/useTimer";
import { formatMilliSecondsToMMSS } from "../../../utils/utilities/FormattedDate";

import classes from "./RecoveryPasswordSendMessage.module.css";

const { Text } = Typography;
const TIMER_SECONDS = 60;

export function RecoveryPasswordSendMessage(): ReactElement {
  const dispatch = useAppDispatch();
  const { emailRecoveryPassword } = useAppSelector((state) => state.authSlice);
  const {
    onStart: onStartTimer,
    timerMilliSeconds,
    onReset: onResetTimer,
  } = useTimer();
  const [disableRepeat, setDisableRepeat] = useState(true);
  const { isFetching, sendQuery } = useThunkActionLoadingState();

  const sendByEmail = async () => {
    onStartTimer();
    setDisableRepeat(true);

    await sendQuery(PASSWORD_RECOVERY_MAIL(emailRecoveryPassword));
  };

  useEffect(() => {
    onStartTimer();
    return () => {
      dispatch(TYPE_POSITION("DEFAULT"));
    };
  }, []);

  useEffect(() => {
    const timerFunc = () => {
      if (
        timerMilliSeconds !== null &&
        timerMilliSeconds >= TIMER_SECONDS * 1000
      ) {
        onResetTimer();
        setDisableRepeat(false);
      }
    };

    timerFunc();
  }, [timerMilliSeconds]);

  const textRepeatBtn = disableRepeat
    ? `Повторить попытку ${formatMilliSecondsToMMSS(
        timerMilliSeconds ? TIMER_SECONDS * 1000 - timerMilliSeconds : 0,
      )}`
    : "Повторить попытку";

  const submitBtnChild = isFetching ? (
    <Spin
      indicator={<LoadingOutlined className="loader-white" spin />}
      size="small"
    />
  ) : (
    textRepeatBtn
  );

  return (
    <LoginFormLayout name="Письмо отправлено">
      <Text className={classes.message}>
        {"Письмо с дальнейшей инструкцией успешно отправлено на адрес "}
        <a href={`mailto:${emailRecoveryPassword}`}>{emailRecoveryPassword}</a>
        {
          ". Проверьте вашу почту или повторите попытку, если вы не получили письмо."
        }
      </Text>

      <Button
        size="large"
        className={`${classes.btn} ${classes.repeat}`}
        type="primary"
        disabled={disableRepeat || isFetching}
        onClick={sendByEmail}
        variant="solid"
      >
        {submitBtnChild}
      </Button>

      <Link to="/login">
        <Button
          size="large"
          className={classes.btn}
          color="primary"
          variant="outlined"
        >
          Войти
        </Button>
      </Link>
    </LoginFormLayout>
  );
}
